import React from "react";
import styled from "styled-components";
// import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg";
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg";
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg";
import { ReactComponent as ProIcon } from "../../Assets/iconsv2/generic/PremiumUser.svg";
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg";
import { ReactComponent as PlatformIconLight } from "../../Assets/iconsv2/generic/BusinessUserLight.svg";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import { displayUserAvatar } from '../../Helpers/chatHelper/AvatarHelper';

const SelectableParticipant = ({ handleClick, participant, selected }) => {
  const { theme } = useGenericComponentsStateService();
  let displayName = participant?.name;

  if (participant?.name === "") {
    displayName = participant?.phone_number;
  }

  return (
    <Warpper onClick={handleClick}>
      <FoundContact>
        <Avatar>
          {displayUserAvatar(participant)}
          <ProBadgeWrapper>
              {participant.is_pro_from_platform ? (
                  theme === "light" ? (
                      <PlatformIconLight />
                  ) : (
                      <PlatformIcon />
                  )
              ) : (
                  participant.is_pro && <ProIcon />
              )}
          </ProBadgeWrapper>
        </Avatar>
        <ContactNameWrapper>
          <Name>{displayName}</Name>
          {selected ? (
            <CheckWrapper>
              <Check />
            </CheckWrapper>
          ) : (
            <CheckEmptyWrapper>
              <CheckEmpty />
            </CheckEmptyWrapper>
          )}
        </ContactNameWrapper>
      </FoundContact>
    </Warpper>
  );
};

export default SelectableParticipant;
const Warpper = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
    &:hover {
    background: ${({ theme }) => theme.call.callElementSelectedBackground};
  }
`;
const FoundContact = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  width: 100%;
`;

const Avatar = styled.div`
  position: relative; 
  display: flex;
  height: 35px;
  width: 35px;
  max-width: 35px;
  min-height: 35px;
  min-width: 35px;
  max-height: 35px;
  overflow: visible;
  border-radius: 100%;
  font-size: 5px;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  svg {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  h5 {
    font-size: 14px;
  }
`;

const ContactNameWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  gap: 10px;
  height: 100%;
  justify-content: space-between;
  svg {
    color: ${({ theme }) => theme.check.background};
    fill: ${({ theme }) => theme.check.checkSign};
  }
`;
const Name = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const CheckWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.background};
    fill: ${({ theme }) => theme.check.checkSign};
  }
`;
const CheckEmptyWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.border};
    stroke: ${({ theme }) => theme.check.checkSign};
    fill: ${({ theme }) => theme.callComponent.participantsListBackground};
  }
`;

const ProBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 20px;
  height: 16px;
  
  svg {
    color: ${({ theme }) => theme.loginButton.background};
  }
`;